import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import "../../styles/sinacceso.css";

// Página 403: el usuario está autenticado pero su rol no tiene acceso a la vista.
export default function SinAcceso() {
    const history = useHistory();

    return (
        <div className="sinacceso-page">
            <div className="sinacceso-card">
                <h1 className="sinacceso-code">403</h1>
                <h2 className="sinacceso-title">Sin acceso</h2>
                <p className="sinacceso-desc">
                    Tu rol no tiene permisos para ver esta sección. Si crees que deberías tener
                    acceso, contacta al administrador.
                </p>
                <Button variant="contained" color="primary" onClick={() => history.push("/")}>
                    Ir al panel principal
                </Button>
            </div>
        </div>
    );
}
